import { render, staticRenderFns } from "./stepIndex.vue?vue&type=template&id=650678e0&scoped=true"
import script from "./stepIndex.vue?vue&type=script&lang=js"
export * from "./stepIndex.vue?vue&type=script&lang=js"
import style0 from "./stepIndex.vue?vue&type=style&index=0&id=650678e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650678e0",
  null
  
)

export default component.exports